// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1LvOf","modal":"Modal_modal__P3_V5","modalHeader":"Modal_modalHeader__2ik2T","title":"Modal_title__kbqpq"};